class AdpHoverTooltipController {
  constructor() {
    this.name = 'adpHoverTooltip';
    this.itemHovered = false;
  }
  hoverIn() {
    this.itemHovered = true;
  }
  hoverOut() {
    this.itemHovered = false;
  }
}

export default AdpHoverTooltipController;



// WEBPACK FOOTER //
// ./src/app/components/adpHoverTooltip/adpHoverTooltip.controller.js